import { defineStore } from 'pinia';
import api from '@/api/api';
// Verifique se o caminho do enum está correto no seu projeto
import statusExerciseEnum from '@/enums/statusExerciseEnum';

export const useExerciseStore = defineStore('exercises', {
    state: () => {
        return {
            exercises : [],
            currentIdExercise: null,
            currentExercise: null
        }
    },
    persist: true,
    getters: {
        hasNextExercise: (state) => {
            return () => {
                const currentGroup = state.currentExercise?.group;
                const groupExercises = state.exercises
                    .filter(e => e.group === currentGroup)
                    .sort((a, b) => a.order - b.order);
                const currentIndex = groupExercises.findIndex(e => e.id === state.currentExercise?.id);

                // Next in same group
                if (currentIndex < groupExercises.length - 1) {
                    return groupExercises[currentIndex + 1];
                }

                // Last in group — go to first of next group
                const groups = [...new Set(state.exercises.map(e => e.group))];
                const groupIndex = groups.indexOf(currentGroup);
                if (groupIndex < groups.length - 1) {
                    const nextGroup = groups[groupIndex + 1];
                    return state.exercises
                        .filter(e => e.group === nextGroup)
                        .sort((a, b) => a.order - b.order)[0];
                }
                return undefined;
            };
        },

        hasPreviousExercise: (state) => {
            return () => {
                const currentGroup = state.currentExercise?.group;
                const groupExercises = state.exercises
                    .filter(e => e.group === currentGroup)
                    .sort((a, b) => a.order - b.order);
                const currentIndex = groupExercises.findIndex(e => e.id === state.currentExercise?.id);

                // Previous in same group
                if (currentIndex > 0) {
                    return groupExercises[currentIndex - 1];
                }

                // First in group — go to last of previous group
                const groups = [...new Set(state.exercises.map(e => e.group))];
                const groupIndex = groups.indexOf(currentGroup);
                if (groupIndex > 0) {
                    const prevGroup = groups[groupIndex - 1];
                    const prevGroupExercises = state.exercises
                        .filter(e => e.group === prevGroup)
                        .sort((a, b) => b.order - a.order);
                    return prevGroupExercises[0];
                }
                return undefined;
            };
        },

        getStringStatus: () => {
            return (status) => statusExerciseEnum.getStringStatus(status);
        }
    },
    actions: {
        setCurrentExercise(exerciseId) {
            this.currentIdExercise = exerciseId;
            this.currentExercise = this.exercises.find(({ id }) => id === exerciseId);
        },

        nextExercise() {
            const currentGroup = this.currentExercise?.group;
            const groupExercises = this.exercises
                .filter(e => e.group === currentGroup)
                .sort((a, b) => a.order - b.order);
            const currentIndex = groupExercises.findIndex(e => e.id === this.currentExercise?.id);

            let exercise = null;

            // Next in same group
            if (currentIndex < groupExercises.length - 1) {
                exercise = groupExercises[currentIndex + 1];
            } else {
                // Last in group — go to first of next group
                const groups = [...new Set(this.exercises.map(e => e.group))];
                const groupIndex = groups.indexOf(currentGroup);
                if (groupIndex < groups.length - 1) {
                    const nextGroup = groups[groupIndex + 1];
                    exercise = this.exercises
                        .filter(e => e.group === nextGroup)
                        .sort((a, b) => a.order - b.order)[0];
                }
            }

            if (exercise) {
                this.currentIdExercise = exercise.id;
                this.currentExercise = exercise;
            }
        },

        previousExercise() {
            const currentGroup = this.currentExercise?.group;
            const groupExercises = this.exercises
                .filter(e => e.group === currentGroup)
                .sort((a, b) => a.order - b.order);
            const currentIndex = groupExercises.findIndex(e => e.id === this.currentExercise?.id);

            let exercise = null;

            // Previous in same group
            if (currentIndex > 0) {
                exercise = groupExercises[currentIndex - 1];
            } else {
                // First in group — go to last of previous group
                const groups = [...new Set(this.exercises.map(e => e.group))];
                const groupIndex = groups.indexOf(currentGroup);
                if (groupIndex > 0) {
                    const prevGroup = groups[groupIndex - 1];
                    const prevGroupExercises = this.exercises
                        .filter(e => e.group === prevGroup)
                        .sort((a, b) => b.order - a.order);
                    exercise = prevGroupExercises[0];
                }
            }

            if (exercise) {
                this.currentIdExercise = exercise.id;
                this.currentExercise = exercise;
            }
        },

        // 👇 AQUI ESTÁ A FUNÇÃO NOVA QUE FALTAVA! 👇
        getGroupedExercises() {
            // Se a lista estiver vazia, retorna um objeto vazio para não quebrar a tela
            if (!this.exercises || this.exercises.length === 0) {
                return {};
            }

            // Agrupa os exercícios pelo nome do grupo que vem do back-end
            return this.exercises.reduce((acc, exercise) => {
                // Tenta pegar o nome do grupo de onde o back-end estiver mandando.
                // Se não vier nome nenhum, joga na "Trilha de Comandos"
                const groupName = exercise.group?.title || exercise.group_name || exercise.group || 'Trilha de Comandos';

                if (!acc[groupName]) {
                    acc[groupName] = { exercises: [] };
                }

                acc[groupName].exercises.push(exercise);
                return acc;
            }, {});
        },

        async updateStatusInProgress(idExercise, statusExercise) {
            if(statusExercise === statusExerciseEnum.NOT_STARTED) {
                await api().put(`/exercise/${idExercise}/status`, { status: statusExerciseEnum.IN_PROGRESS });
            }
        },

        async updateStatusCompleted(idExercise) {
            try {
                await api().put(`/exercise/${idExercise}/status`, { status: statusExerciseEnum.COMPLETED });
                this.currentExercise.status = statusExerciseEnum.COMPLETED;
                const exercise = this.exercises.find(e => e.id === idExercise);
                if (exercise) exercise.status = statusExerciseEnum.COMPLETED;
            } catch (error) {
                if (error.response?.status === 400 && error.response?.data?.detail === 'Exercise already completed') {
                    this.currentExercise.status = statusExerciseEnum.COMPLETED;
                    const exercise = this.exercises.find(e => e.id === idExercise);
                    if (exercise) exercise.status = statusExerciseEnum.COMPLETED;
                    return;
                }
                throw error;
            }
        },

        async saveLog(logContent) {
            await api().post('/log/exercise/' + this.currentIdExercise, { content: logContent });
        }
    }
})